import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useStore } from 'store'
import { ConfirmAddedResource } from 'icons'
import copy from 'copy.json'
import { clientPanelPaths } from 'paths'

import Button from 'components/Button'

const text = copy.page.client_panel.confirmation

export default function ConfirmationScreen() {
  const { currentLoginUserClientPanel } = useStore()
  const navigate = useNavigate()

  const onGoToResourcesList = () => {
    if (currentLoginUserClientPanel?.type === 'BUYER') {
      navigate(clientPanelPaths.demand_data)
      return
    }

    if (currentLoginUserClientPanel?.type === 'SELLER') {
      navigate(clientPanelPaths.offer_data)
      return
    }

    navigate(clientPanelPaths.personal_data)
  }

  const buttonText =
    currentLoginUserClientPanel?.type === 'BUYER' ? text.button_demand : text.button_offer

  const paragraphText =
    currentLoginUserClientPanel?.type === 'BUYER' ? text.paragraph_demand : text.paragraph_offer

  return (
    <Wrapper>
      <Step>
        <h1>{text.heading}</h1>

        <p>{paragraphText}</p>

        <ConfirmAddedResource />

        <Button onClick={onGoToResourcesList}>{buttonText}</Button>
      </Step>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  max-width: 646px;
  margin: 40px auto 0;

  background: var(--white);
  border-radius: 4px;
`

const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 24px 16px;

  width: 100%;
  max-width: 336px;
  margin: 0 auto;

  > h1 {
    align-self: center;
    font: var(--600-24);
    text-align: center;
  }

  > p {
    font: var(--400-13);
    align-self: center;
    text-align: center;
  }

  > ${Button} {
    width: 100%;
    max-width: 312px;
    align-self: center;
  }
`
